<template functional>
  <div>
    <div>{{ props.item.ctype }}</div>
    <div class="text-2xs">{{ props.item.weight }}</div>
  </div>
</template>

<script>
export default {
  name: "drayage-ctype",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
